import { http } from '@/http'

export default {
  createPeriod(data) {
    return http.post('/payroll-engine/create', data)
  },
  calculate(id) {
    return http.post(`/payroll-engine/${id}/calculate`)
  },
  approve(id) {
    return http.post(`/payroll-engine/${id}/approve`)
  },
  pay(id, paidAt) {
    return http.post(`/payroll-engine/${id}/pay`, null, { params: { paidAt } })
  },
  annul(id) {
    return http.post(`/payroll-engine/${id}/annul`)
  },
  recalculate(id) {
    return http.post(`/payroll-engine/${id}/recalculate`)
  },
  get(id) {
    return http.get(`/payroll-engine/${id}`)
  },
  getDetails(id) {
    return http.get(`/payroll-engine/${id}/details`)
  },
  list(companyId, year) {
    return http.get('/payroll-engine', { params: { companyId, year } })
  },
  exportExcel(id) {
    return http.get(`/payroll-engine/${id}/export`, { responseType: 'blob' })
  },
}
